import styled from 'styled-components';

export const AmenitiesSection = styled.section`
  padding-bottom: 50px;
  
  @media(min-width: 768px) {
    margin-bottom: 50px;
    margin-bottom: 45px;
    border-bottom: 1px solid ${({ theme }) => theme.lightGray};
  }
`;

export const AmenitiesContainer = styled.div`
  @media(min-width: 768px) {
    padding: 0 40px;
  }
  
  @media(min-width: 1024px) {
    padding: 0;
  }
`;

export const AmenitiesHeading = styled.h2`
  margin: 0;
  margin-bottom: 10px;
  padding: 0 10px;
  
  font-size: 18px;
  line-height: 1;
  
  @media(min-width: 768px) {
    padding: 0;
    
    font-size: 24px;
  }
`;

export const AmenitiesColumnContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 55px;
  padding-top: 50px;
    
  border-top: 1px solid ${({ theme }) => theme.lightGray};
  
  &:empty {
    display: none;
  }
`;

export const AmenitiesColumn = styled.div`
  width: 46%;
`;

export const AmenitiesColumnHeading = styled(AmenitiesHeading)`
  margin-bottom: 20px;
`;

export const AmenitiesList = styled.ul`
  column-count: ${({ twoColumn }) => twoColumn ? 2 : 1};
  
  a {
    color: ${({ theme }) => theme.blue};
    
    transition: color 0.3s;
    
    &:hover {
      color: ${({ theme }) => theme.black};
    }
  }

  li {
    position: relative;
    
    padding-left: 18px;
    
    font-size: 16px;
    line-height: 1;
    
    &:not(:last-child) {
      margin-bottom: 15px;
    }
    
    &::before {
      content: "";
      
      position: absolute;
      top: 5px;
      left: 0;
      
      width: 6px;
      height: 6px;
      
      border-radius: 50%;
      background-color: #a8a8a8;
    }
  }
`;

export const WorkingHours = styled.li`
  position: relative;
  
  display: flex;
  align-items: center;
  margin-top: 25px;
  
  font-weight: 700;
  font-size: 14px;
  line-height: 19px;
  color: ${({ theme }) => theme.blue};
  
  a {
    color: inherit;
    
    transition: color 0.3s;
    
    &:hover {
      color: ${({ theme }) => theme.blue};
    }
  }
  
  span {
    margin-right: 10px;
    font-weight: 400;
    color: ${({ theme }) => theme.black};
    font-style: normal;
  }
  
  @media(min-width: 768px) {
    font-size: 16px;
    line-height: 1;
  }
`;

export const WorkingHoursIcon = styled.div`
  width: 30px;
`;
